/* Vintage Box: one-question-at-a-time quiz on the product page + straight to checkout */
(function () {
  var STEP_RE = /kg-mystery-form-group-(\d+)/;
  var TITLES = { 1: 'Your vibe', 2: 'Your sizing', 3: 'Build your outfit', 4: 'Add some shine', 5: 'Brands you love', 6: 'Anything to skip?' };

  function stepOf(g) { var m = g.className.match(STEP_RE); return m ? +m[1] : 0; }
  function isVisible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  function init() {
    var wrap = document.querySelector('.gpo-container .gpo-group__childs');
    if (!wrap) return false;
    if (wrap.dataset.vbq) return true;
    var groups = Array.prototype.filter.call(wrap.children, function (g) { return g.classList.contains('gpo-form__group'); });
    var steps = Array.from(new Set(groups.map(stepOf).filter(Boolean))).sort(function (a, b) { return a - b; });
    if (steps.length < 2) return true;
    wrap.dataset.vbq = '1';
    document.body.classList.add('vbq-on');

    groups.forEach(function (g) { if (g.classList.contains('kg-mystery-form-steps-toggle-wrapper')) g.classList.add('vbq-hide'); });

    var form = document.querySelector('form[action*="/cart/add"][id^="product-form-template"]') || document.querySelector('product-form form');
    var atc = form && form.querySelector('[name="add"]');
    var gpoApp = wrap.closest('.gpo-app') || wrap.parentElement;

    var top = document.createElement('div');
    top.className = 'vbq-progress';
    top.innerHTML = '<div class="vbq-progress__row"><span class="vbq-progress__label"></span><span class="vbq-progress__count"></span></div><div class="vbq-progress__track"><div class="vbq-progress__bar"></div></div>';
    gpoApp.parentNode.insertBefore(top, gpoApp);

    var nav = document.createElement('div');
    nav.className = 'vbq-nav';
    nav.innerHTML = '<button type="button" class="vbq-back">Back</button><button type="button" class="vbq-next button">Next</button>';
    gpoApp.parentNode.insertBefore(nav, gpoApp.nextSibling);
    var back = nav.querySelector('.vbq-back'), next = nav.querySelector('.vbq-next');

    var two = document.createElement('label');
    two.className = 'vbq-two';
    two.innerHTML = '<input type="checkbox"><span><strong>Make it 2 boxes, save 10% on both</strong><br>Two full fits in your style, each styled separately.</span>';
    gpoApp.parentNode.insertBefore(two, nav);
    var twoBox = two.querySelector('input');
    twoBox.addEventListener('change', function () {
      if (!form) return;
      var q = form.querySelector('input[name="quantity"]');
      if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; form.appendChild(q); }
      q.value = twoBox.checked ? '2' : '1';
    });

    var cur = 0;
    function render() {
      var s = steps[cur];
      groups.forEach(function (g) { var gs = stepOf(g); g.classList.toggle('vbq-off', !!gs && gs !== s); });
      top.querySelector('.vbq-progress__label').textContent = TITLES[s] || 'Your box';
      top.querySelector('.vbq-progress__count').textContent = 'Step ' + (cur + 1) + ' of ' + steps.length;
      top.querySelector('.vbq-progress__bar').style.width = ((cur + 1) / steps.length * 100) + '%';
      back.style.visibility = cur === 0 ? 'hidden' : 'visible';
      var last = cur === steps.length - 1;
      next.style.display = last ? 'none' : '';
      two.style.display = last ? '' : 'none';
      document.body.classList.toggle('vbq-last', last);
      if (atc) { var sp = atc.querySelector('span'); if (sp) sp.textContent = 'Get my outfit'; }
    }

    function missing() {
      var s = steps[cur], bad = [];
      groups.forEach(function (g) {
        if (stepOf(g) !== s || !isVisible(g)) return;
        if (!g.querySelector('label.gpo-label.required')) return;
        var ok = Array.prototype.some.call(g.querySelectorAll('input,select,textarea'), function (i) {
          if (i.type === 'radio' || i.type === 'checkbox') return i.checked;
          return (i.value || '').trim() !== '';
        });
        if (!ok) bad.push(g);
      });
      return bad;
    }

    function go(d) {
      if (d > 0) {
        var bad = missing();
        groups.forEach(function (g) { g.classList.remove('vbq-err'); });
        if (bad.length) {
          bad.forEach(function (g) { g.classList.add('vbq-err'); });
          bad[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
      cur = Math.max(0, Math.min(steps.length - 1, cur + d));
      render();
      var y = top.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    back.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    wrap.addEventListener('change', function (e) {
      var g = e.target.closest('.gpo-form__group');
      if (g) g.classList.remove('vbq-err');
    });

    if (atc) {
      atc.addEventListener('click', function () {
        if (missing().length) return;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (before) {
          var start = Date.now();
          (function poll() {
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
              if (c.item_count > before.item_count) { window.location.href = '/checkout'; return; }
              if (Date.now() - start < 10000) setTimeout(poll, 400);
            });
          })();
        });
      }, true);
    }

    render();
    return true;
  }

  var tries = 0;
  var t = setInterval(function () { tries++; if (init() || tries > 60) clearInterval(t); }, 250);
})();
